// extracted by mini-css-extract-plugin
export default {"wrapper":"Support_wrapper--VBb","button":"Support_button--UQs","hidden":"Support_hidden--iA3","needHelp":"Support_needHelp--_aJ"};